import { COMPANY } from "@/lib/company";

export default function WhatsAppButton() {
  const msg = encodeURIComponent(
    "Hello Aad Labs, I would like to inquire about your botanical extracts / spices export."
  );
  return (
    <a
      data-testid="whatsapp-floating-button"
      href={`https://wa.me/${COMPANY.phoneRaw}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] shadow-lg hover:shadow-xl hover:scale-105 transition-transform flex items-center justify-center"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 text-white" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.29c-.29-.15-1.71-.84-1.98-.94-.27-.1-.46-.15-.66.15s-.76.94-.93 1.13c-.17.2-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.71-1.61-2s-.02-.45.13-.6c.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.52-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48c0 1.46 1.06 2.87 1.21 3.06.15.2 2.09 3.19 5.06 4.47.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.08 1.71-.7 1.96-1.37s.24-1.25.17-1.37c-.07-.12-.27-.2-.56-.34zM16.03 5.33c-6 0-10.87 4.87-10.87 10.87 0 1.92.5 3.77 1.45 5.4L5 27.33l5.87-1.55c1.57.86 3.34 1.31 5.15 1.31 6 0 10.87-4.87 10.87-10.87S22.02 5.33 16.03 5.33z" />
      </svg>
    </a>
  );
}
